
<flo-view-as-widget 
  #viewAsWidget 
  [isViewingAsUser$]="isViewingAsUser"
  [viewedUserInfo$]="viewedUserInfo"
></flo-view-as-widget>

<!-- Prominent banner when viewing as another user -->
<div *ngIf="isViewingAsUser | async" class="view-as-banner" [ngClass]="{'collapsed': isCollapsed}">
  <div class="view-as-banner-content">
    <span class="view-as-title">
      <strong>⚠️ ADMIN VIEW-AS MODE</strong>
    </span>
    <span class="view-as-details" *ngIf="viewedUserInfo | async as userInfo">
      Viewing as: 
      <strong>{{ userInfo.name || userInfo.email }}</strong>
      <span *ngIf="userInfo.name" class="text-muted">({{ userInfo.email }})</span>
      <span class="text-muted">ID: {{ userInfo.id }}</span>
    </span>
    <button class="btn btn-sm btn-light" (click)="viewAsWidget.openWindow()">
      Exit View-As Mode
    </button>
  </div>
</div>

<!-- Collapse button - stays fixed outside the banner -->
<button *ngIf="isViewingAsUser | async" class="collapse-button" (click)="toggleCollapsed()" [title]="isCollapsed ? 'Show admin view-as banner' : 'Hide admin view-as banner'">
  {{ isCollapsed ? '▼' : '▲' }}
</button>

<div *ngIf="(debug.debugOn$ | async) || (isViewingAsUser | async)" class="debug-menu p-2">
  <flo-experimentation-widget #expWidget></flo-experimentation-widget>
  <flo-select-input
    [options]="selectMenuItems$ | async"
    [initial]="vs.siteCode$ | async"
    (selected$)="changeVertical($event)"
  ></flo-select-input>
  <button
    *ngIf="canViewAsUser$ | async"
    [class]="(isViewingAsUser | async) ? 'btn btn-danger w-100 mt-1' : 'btn btn-primary primary-color-bg w-100 mt-1'"
    (click)="viewAsWidget.openWindow()"
  >
    {{ (isViewingAsUser | async) ? 'Exit View-As' : 'View As User' }}
  </button>
  <button
    class="btn btn-primary primary-color-bg w-100 mt-1"
    (click)="expWidget.toggleWindow()"
    >Experiments</button
  >
</div>
